import { useEffect, useRef } from "react"

/**
 * Calls `fit` when the past-stops overlay is switched on, or the room changes
 * while it is on, provided the overlay has stops at that moment. Stops
 * arriving later (the driver completes the first stop of an order) never move
 * the map, so a dispatcher who panned away stays where they are.
 */
export function useFitWhenPastStopsShown({
  enabled,
  roomJid,
  hasStops,
  fit,
}: {
  enabled: boolean
  roomJid: string | undefined
  hasStops: boolean
  fit: () => void
}) {
  const latest = useRef({ hasStops, fit })
  useEffect(() => {
    latest.current = { hasStops, fit }
  })

  useEffect(() => {
    if (enabled && roomJid && latest.current.hasStops) latest.current.fit()
  }, [enabled, roomJid])
}
